export type WebAudioArtifactMetadata = Record<string, unknown>;

export enum WebAudioArtifactState {
  Writing = "writing",
  Finalized = "finalized",
}

export type WebAudioArtifactChunk = {
  blob: Blob;
  byteLength: number;
  durationMs: number;
  mimeType: string;
};

export type WebAudioArtifactRef = {
  artifactId: string;
  key: string;
  mimeType: string;
  sizeBytes: number;
  durationMs: number;
  chunkCount: number;
  metadata?: WebAudioArtifactMetadata;
};

export type WebAudioArtifactSnapshot = WebAudioArtifactRef & {
  state: WebAudioArtifactState;
};
